import { datadogRum } from "@datadog/browser-rum";

export const initDatadog = () => {
  let activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "local";

  if (activeEnv === "prod") {
    datadogRum.init({
      applicationId: process.env.DATADOG_APPLICATION_ID || "",
      clientToken: process.env.DATADOG_CLIENT_TOKEN || "",
      site: process.env.DATADOG_SITE,
      service: process.env.DATADOG_SERVICE,
      env: activeEnv,
      version: process.env.BUILD_VERSION,
      sessionSampleRate: 20,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });

    datadogRum.startSessionReplayRecording();
  }
};
